import React from "react";
import { Award, ExternalLink, Clock } from "lucide-react";
import { certifications } from "../data/mock";

const issuerColors = {
  "Amazon Web Services": { bg: "bg-amber-500/8", border: "border-amber-500/15", text: "text-amber-400", dot: "bg-amber-400" },
  "Google": { bg: "bg-emerald-500/8", border: "border-emerald-500/15", text: "text-emerald-400", dot: "bg-emerald-400" },
  "ITIL": { bg: "bg-violet-500/8", border: "border-violet-500/15", text: "text-violet-400", dot: "bg-violet-400" },
};

const Certifications = () => {
  return (
    <section id="certifications" className="relative py-24 sm:py-32">
      {/* Top divider */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-zinc-800 to-transparent" />

      <div className="max-w-6xl mx-auto px-6">
        {/* Section header */}
        <div className="mb-16">
          <p className="text-blue-400 text-sm font-medium font-mono tracking-wide mb-3">
            05 — Certifications
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white tracking-tight mb-4">
            Certifications
          </h2>
          <p className="text-zinc-500 text-base max-w-lg">
            Industry-recognized credentials validating cloud and IT expertise.
          </p>
        </div>

        {/* Certifications Grid */}
        <div className="grid sm:grid-cols-3 gap-5">
          {certifications.map((cert) => {
            const colors = issuerColors[cert.issuer] || { bg: "bg-blue-500/8", border: "border-blue-500/15", text: "text-blue-400", dot: "bg-blue-400" };
            const isCompleted = cert.status === "Completed";

            return (
              <div
                key={cert.id}
                className="group relative p-6 sm:p-7 rounded-xl bg-white/[0.02] border border-white/5 hover:border-blue-500/15 transition-all duration-300 hover:bg-blue-500/[0.02]"
              >
                {/* Icon */}
                <div className={`w-11 h-11 rounded-lg ${colors.bg} border ${colors.border} flex items-center justify-center mb-5 group-hover:scale-105 transition-transform duration-300`}>
                  <Award size={20} className={colors.text} />
                </div>

                {/* Title */}
                <h3 className="text-base font-semibold text-white mb-1.5">
                  {cert.title}
                </h3>

                {/* Issuer */}
                <p className="text-sm text-zinc-500 mb-4">
                  {cert.issuer}
                </p>

                {/* Status */}
                <div className="flex items-center gap-2">
                  {isCompleted ? (
                    <>
                      <span className={`w-1.5 h-1.5 rounded-full ${colors.dot}`} />
                      <span className={`text-xs font-medium ${colors.text}`}>
                        Completed
                      </span>
                    </>
                  ) : (
                    <>
                      <Clock size={12} className="text-zinc-500" />
                      <span className="text-xs font-medium text-zinc-500">
                        {cert.status}
                      </span>
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
